// Конфигурация Keycloak — читается из Vite env (VITE_KEYCLOAK_*).
// PKCE flow обеспечивает @dss/auth (oidc-client-ts).
//
// `authority` / `client_id` — статические, из env-vars build-time.
// `redirect_uri` / `post_logout_redirect_uri` — динамические через
// `window.location.origin`, потому что client SPA рендерится на любом
// `<slug>.ds2b.ru` (S21 / D14-Arch-3). Хардкод одного хоста (например
// `https://app.ds2b.ru/auth/callback`) ломает OIDC на всех остальных
// хостах: KC redirect-ит на фиксированный URL, попадает в SPA с другой
// in-memory сессией → state не совпадает → callback зависает.
import type { AuthConfig } from '@dss/auth'

function requireEnv(key: string, fallback: string): string {
  const value = import.meta.env[key as keyof ImportMetaEnv] as string | undefined
  return value ?? fallback
}

export const authConfig: AuthConfig = {
  authority: requireEnv(
    'VITE_KEYCLOAK_AUTHORITY',
    'http://localhost:8080/realms/distribution-software-sales',
  ),
  client_id: requireEnv('VITE_KEYCLOAK_CLIENT_ID', 'dss-backend'),
  redirect_uri: `${window.location.origin}/auth/callback`,
  post_logout_redirect_uri: `${window.location.origin}/logout`,
}
